<template>
  <div class="flex items-center gap-4 w-full">
    <vue-feather
      type="more-vertical"
      class="h-6 opacity-25 cursor-not-allowed"
      v-if="task.checklist_taskable_type === 'ChecklistOnboardingFormTask'"
    />
    <vue-feather type="more-vertical" class="h-6 drag-handle" v-else />
    <div class="border border-gray-200 rounded p-6 flex items-center justify-between bg-white flex-grow">
      <div class="flex-grow">
        <header class="font-bold text-gray-900">{{ task.name }}</header>
        <div class="bg-gray-100 rounded-lg px-2 py-1 text-xs mt-4 inline-block">
          <vue-feather type="user" class="h-4 inline-block" />
          {{ assignee }}
        </div>
      </div>
      <router-link :to="checklistTaskEditUrl">
        <TButton color="white" label="Edit" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      required: true,
      type: Object,
    },
    assignableUsers: {
      required: true,
      type: Array,
    },
    taskChecklist: {
      required: true,
      type: Object,
    },
  },
  computed: {
    assignee() {
      if (this.task.assigned_to_role === 'agent') {
        return 'Agent';
      } else {
        return this.assignableUsers.find(user => parseInt(user.value) === parseInt(this.task.assigned_to_user_id))
          ?.label;
      }
    },
    checklistTaskEditUrl() {
      if (this.taskChecklist.checklist_type === 'onboarding') {
        return `/settings/company/onboarding_checklists/${this.taskChecklist.id}/tasks/${this.task.id}/edit`;
      } else {
        return `/settings/company/training_checklists/${this.taskChecklist.id}/tasks/${this.task.id}/edit`;
      }
    },
  },
};
</script>
